/* eslint-disable @typescript-eslint/no-throw-literal */
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { IFetchLaboratoryTestPropertiesParams, ILaboratoryTestProperty } from '~/interfaces'
import { fetchLaboratoryTestProperties, message } from '~/services'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'laboratoryTestProperties'

const EMPTY = ''
const sampleIsNotEmpty = (property: any): boolean => property.sample.trim() !== EMPTY

export const useFetchLaboratoryTestProperties = (
  fetchParams: IFetchLaboratoryTestPropertiesParams | null,
  config?: UseQueryOptions<ILaboratoryTestProperty[], Error, ILaboratoryTestProperty[]>
): UseQueryResult<ILaboratoryTestProperty[], Error> => {
  const hasFetchParams = hasObjectValue({ ...fetchParams })
  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')

    try {
      const response = await fetchLaboratoryTestProperties(fetchParams)
      const isResponseEmpty = response.length === 0

      if (isResponseEmpty) {
        throw message('detailsMedicalEvents.laboratoryPropertyEmpty')
      }

      return response.filter(sampleIsNotEmpty)
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('detailsMedicalEvents.laboratoryPropertyUnexpectedError'))
    }
  }

  return useQuery<ILaboratoryTestProperty[], Error>([UNIQUE_KEY, fetchParams?.pathParams], fetcher, {
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled: hasFetchParams,
    ...config
  })
}
